const ServicesList = ({heading, list}) => {
  return (
    <>
      <h4>{heading}</h4>

      <ul>
        {list.map((item, index) => <li key={index}>{item}</li>)}
      </ul>
    </>
  )
}

export default ServicesList;
